import {
  EStoreStartSubmitFormData,
  ESTORE_SUBMIT_DATA_INFO,
  StartLoadingAgencyInfoAction,
  START_LOADING_AGENCY_INFO,
} from '../EStore.types';

export const startLoadEStoreAgency = (slug: string): StartLoadingAgencyInfoAction => ({
  type: START_LOADING_AGENCY_INFO,
  slug,
});

export const startSubmitEStoreFormData = (): EStoreStartSubmitFormData => ({
  type: ESTORE_SUBMIT_DATA_INFO,
});
